<template>
  <div id="pay-ensure-modal">
    <el-dialog title="订单支付" v-model="showModal" custom-class="pay-dialog" :show-close="false" @close="cancelPayDialog">
      <span>该订单将使用余额支付, 是否确认支付?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelPayDialog">取 消</el-button>
        <el-button type="primary" @click="orderSubmitAndPay" :loading="showLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'pay-ensure-modal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    showLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.value,
    };
  },
  methods: {

    // 取消确认支付弹窗
    cancelPayDialog() {
      this.$emit('input', false);
      MtaH5.clickStat('payvisaorder0cancel');
    },

    // 点击确认
    orderSubmitAndPay() {
      this.$emit('ensure');
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
  },
};
</script>

<style lang="less">
#pay-ensure-modal {
  .pay-dialog {
    width: 480px;
    text-align: center;
    border-radius: 5px;

    .el-dialog__header {
      padding-top: 48px;
    }

    .el-dialog__title {
      font-size: 22px;
      color: #333;
      font-weight: 300;
    }

    .el-dialog__body {
      font-size: 18px;
      padding: 38px 20px;
      line-height: 1.5;
    }

    .el-dialog__footer {
      text-align: center;
      padding-bottom: 38px;

      .el-button {
        width: 150px;
        font-size: 16px;

        & + .el-button {
          margin-left: 22px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/pay-ensure-modal.vue